
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apipages/reference/response/[schema]",
      function () {
        return require("private-next-pages/apipages/reference/response/[schema]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apipages/reference/response/[schema]"])
      });
    }
  